import type { Optional } from '@/shared/interfaces'
import type { TEndereco } from '@/shared/interfaces/cliente.types'

export const formatarProfissaoLocalizacao = (
  profissao?: string | null,
  endereco?: Optional<TEndereco, 'cidade' | 'uf'> | null,
): string => {
  const cidade = endereco?.cidade?.trim()
  const uf = endereco?.uf?.trim()

  const local = [cidade, uf].filter(Boolean).join(' - ')
  const temProfissao = !!profissao
  const temLocal = !!local

  if (!temProfissao && !temLocal) return '-'
  if (temProfissao && temLocal) return `${profissao} • ${local}`
  if (temProfissao) return profissao
  return local
}
